/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationPreferenceDeliveryScopeType } from './NotificationPreferenceDeliveryScopeType';
import {
    NotificationPreferenceDeliveryScopeTypeFromJSON,
    NotificationPreferenceDeliveryScopeTypeFromJSONTyped,
    NotificationPreferenceDeliveryScopeTypeToJSON,
    NotificationPreferenceDeliveryScopeTypeToJSONTyped,
} from './NotificationPreferenceDeliveryScopeType';

/**
 * 
 * @export
 * @interface NotificationPreferenceDeliveryScope
 */
export interface NotificationPreferenceDeliveryScope {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    user_id?: string;
    /**
     * 
     */
    preference_id?: string;
    /**
     * 
     */
    relation_type?: NotificationPreferenceDeliveryScopeType;
    /**
     * 
     */
    relation_id?: string;
    /**
     * 
     */
    enabled?: boolean;
}



/**
 * Check if a given object implements the NotificationPreferenceDeliveryScope interface.
 */
export function instanceOfNotificationPreferenceDeliveryScope(value: object): value is NotificationPreferenceDeliveryScope {
    return true;
}

export function NotificationPreferenceDeliveryScopeFromJSON(json: any): NotificationPreferenceDeliveryScope {
    return NotificationPreferenceDeliveryScopeFromJSONTyped(json, false);
}

export function NotificationPreferenceDeliveryScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationPreferenceDeliveryScope {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'user_id': json['user_id'] == null ? undefined : json['user_id'],
        'preference_id': json['preference_id'] == null ? undefined : json['preference_id'],
        'relation_type': json['relation_type'] == null ? undefined : NotificationPreferenceDeliveryScopeTypeFromJSON(json['relation_type']),
        'relation_id': json['relation_id'] == null ? undefined : json['relation_id'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
    };
}

export function NotificationPreferenceDeliveryScopeToJSON(json: any): NotificationPreferenceDeliveryScope {
    return NotificationPreferenceDeliveryScopeToJSONTyped(json, false);
}

export function NotificationPreferenceDeliveryScopeToJSONTyped(value?: NotificationPreferenceDeliveryScope | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_id': value['user_id'],
        'preference_id': value['preference_id'],
        'relation_type': NotificationPreferenceDeliveryScopeTypeToJSON(value['relation_type']),
        'relation_id': value['relation_id'],
        'enabled': value['enabled'],
    };
}

